import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { registerNotify } from "../utils/notifyBridge";

const NotificationContext = createContext({ notify: () => {} });

export const NotificationProvider = ({ children }) => {
  const [state, setState] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const notify = useCallback((message, severity = "success") => {
    if (!message) return;
    const text = String(message);
    const silent = /authentication required|device authentication required|csrf validation failed/i.test(
      text
    );
    if (silent && severity === "error") return;
    setState((prev) => {
      if (prev.open && prev.message === text) return prev;
      return { open: true, message: text, severity };
    });
  }, []);

  const close = useCallback(() => {
    setState((s) => ({ ...s, open: false }));
  }, []);

  useEffect(() => {
    registerNotify(notify);
    return () => registerNotify(null);
  }, [notify]);

  const value = useMemo(() => ({ notify }), [notify]);

  return (
    <NotificationContext.Provider value={value}>
      {children}
      <Snackbar
        open={state.open}
        autoHideDuration={4000}
        onClose={close}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ zIndex: 9999 }}
      >
        <Alert onClose={close} severity={state.severity} variant="filled">
          {state.message}
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  );
};

export const useNotify = () => useContext(NotificationContext);
